export default "__VITE_ASSET__9LfQjsRd__"